/* ================================================
   AT-HOME PAGE JAVASCRIPT - Consolidated & Optimized
   ================================================ */

(function() {
  'use strict';

  // ========================================
  // CONFIGURATION
  // ========================================
  const CONFIG = {
    TOKEN_URL: 'https://supertails-backend.el.r.appspot.com/otp/token',
    SEND_OTP_URL: 'https://omqkhavcch.execute-api.ap-south-1.amazonaws.com/simplyotplogin/v6/otp',
    VERIFY_OTP_URL: 'https://omqkhavcch.execute-api.ap-south-1.amazonaws.com/simplyotplogin/v6/otp',
    PARTIAL_LEADS_URL: 'https://supertails-backend.el.r.appspot.com/HealthCare/partial-leads',
    IFRAME_BASE_URL: 'https://lively-rabanadas-04928e.netlify.app/at-home',
    SHOP_NAME: 'supertail.myshopify.com',
    RESEND_TIMEOUT: 60
  };

  // ========================================
  // STATE
  // ========================================
  const state = {
    otpId: '',
    channel: 'phone',
    currentScreen: 'login',
    authToken: null,
    iframeLoaded: false,
    iframeError: false,
    otpInputsInitialized: false
  };

  const timers = {
    countdown: null,
    otpStatus: null
  };

  // ========================================
  // DOM ELEMENTS
  // ========================================
  const elements = {
    // Inputs
    phoneInput: document.getElementById('bkLoginPhone'),
    phoneInputDesktop: document.getElementById('bkLoginPhoneDesktop'),
    
    // Buttons
    getOtpBtn: document.getElementById('bkGetOtpBtn'),
    getOtpBtnDesktop: document.getElementById('bkGetOtpBtnDesktop'),
    verifyBtn: document.getElementById('stVerifyBtn'),
    resendBtn: document.getElementById('stResendBtn'),
    retryBtn: document.getElementById('booking-retry-btn'),
    
    // UI Screens
    loginUi: document.getElementById('bkLoginUi'),
    loginUiDesktop: document.getElementById('bkLoginUiDesktop'),
    otpUi: document.querySelector('section.st-otp-ui'),
    registrationUi: document.getElementById('stRegistrationUi'),

    // Registration form elements
    regFirstName: document.getElementById('stFirstName'),
    regLastName: document.getElementById('stLastName'),
    regEmail: document.getElementById('stEmail'),
    regPhone: document.getElementById('stRegPhone'),
    registerBtn: document.getElementById('stRegisterBtn'),
    registrationForm: document.getElementById('stRegistrationForm'),
    
    // Text elements
    otpPhoneText: document.getElementById('stOtpPhone'),
    resendTimer: document.getElementById('stResendTimer'),
    
    // Iframe
    iframe: document.getElementById('booking-frame'),
    frameWrap: document.getElementById('booking-frame-wrap'),
    
    // OTP boxes
    otpBoxes: Array.from(document.querySelectorAll('.st-otp-ui__box')),
    
    // Links
    waToggleLinks: Array.from(document.querySelectorAll('.st-login-ui__wa, .st-login-ui-desktop__wa, .st-otp-ui__wa'))
  };

  // ========================================
  // UTILITY FUNCTIONS
  // ========================================
  
  function clean(value) {
    return (value || '').replace(/\D/g, '').slice(0, 10);
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;
    
    const btnText = button.querySelector('.btn-text');
    const btnLoading = button.querySelector('.btn-loading');
    
    if (isLoading) {
      button.classList.add('is-loading');
      button.disabled = true;
      if (btnText) btnText.style.display = 'none';
      if (btnLoading) btnLoading.style.display = 'flex';
    } else {
      button.classList.remove('is-loading');
      if (btnText) btnText.style.display = 'inline';
      if (btnLoading) btnLoading.style.display = 'none';
    }
  }

  // ========================================
  // URL HANDLING
  // ========================================
  
  const URLHandler = {
    getServiceFromPath() {
      const pathParts = window.location.pathname.split('/');
      const urlParams = new URLSearchParams(window.location.search);
      const serviceFromQuery = urlParams.get('service');
      
      if (serviceFromQuery) return serviceFromQuery;
      
      for (let i = 0; i < pathParts.length; i++) {
        if (pathParts[i] === 'athome' && i + 1 < pathParts.length) {
          const nextPart = pathParts[i + 1];
          if (!/^\d+$/.test(nextPart)) return nextPart;
        }
      }
      return 'consultation';
    },

    getClinicIdFromPath() {
      const pathParts = window.location.pathname.split('/');
      const urlParams = new URLSearchParams(window.location.search);
      const clinicIdFromQuery = urlParams.get('clinicId');
      
      if (clinicIdFromQuery) return clinicIdFromQuery;
      
      for (let i = 0; i < pathParts.length; i++) {
        if (pathParts[i] === 'clinic-consultation' && i + 1 < pathParts.length) {
          const nextPart = pathParts[i + 1];
          if (/^\d+$/.test(nextPart)) return nextPart;
        }
      }
      return '';
    },

    constructIframeUrl(phoneNumber) {
      const service = this.getServiceFromPath();
      const clinicId = this.getClinicIdFromPath();
      const currentPhone = phoneNumber || localStorage.getItem('_customerPhone') || window.currentLoginPhone;
      const customerId = localStorage.getItem('_customerId');
      
      
      let url = `${CONFIG.IFRAME_BASE_URL}/${service}?web=true`;
      
      if (currentPhone) url += `&phone=${currentPhone}`;
      if (customerId) url += `&userId=${customerId}`;
      if (clinicId) url += `/${clinicId}`;
      
      if (elements.iframe) elements.iframe.src = url;
      
      window.bookingUrl = url;
      return url;
    }
  };

  // Legacy function for backward compatibility
  window.getServiceFromPath = () => URLHandler.getServiceFromPath();
  window.getClinicIdFromPath = () => URLHandler.getClinicIdFromPath();
  window.constructIframeUrl = (phone) => URLHandler.constructIframeUrl(phone);

  // ========================================
  // API FUNCTIONS
  // ========================================
  
  async function getAuthToken() {
    try {
      const response = await fetch(CONFIG.TOKEN_URL, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error('Failed to get auth token');
      
      const data = await response.json();
      if (data.success && data.data && data.data.token) {
        state.authToken = data.data.token;
        return state.authToken;
      }
      throw new Error('Invalid token response');
    } catch (error) {
      console.error('Error getting auth token:', error);
      console.warn('Proceeding without auth token');
      return null;
    }
  }

  async function sendOtp() {
    const phoneNumber = clean(elements.phoneInput.value || elements.phoneInputDesktop.value);
    if (phoneNumber.length !== 10) return;
    
    window.currentLoginPhone = phoneNumber;
    localStorage.setItem('_customerPhone', phoneNumber);
    URLHandler.constructIframeUrl(phoneNumber);
    
    setButtonLoading(elements.getOtpBtn, true);
    setButtonLoading(elements.getOtpBtnDesktop, true);
    
    try {
      const authToken = await getAuthToken();
      
      const headers = {
        'shop_name': CONFIG.SHOP_NAME,
        'action': 'sendOTP',
        'Content-Type': 'application/json'
      };
      
      if (authToken) headers['Authorization'] = authToken;
      
      const response = await fetch(CONFIG.SEND_OTP_URL, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          username: `+91${phoneNumber}`,
          type: state.channel
        })
      });
      
      const data = await response.json();
      
      if (data.status !== 200) {
        throw new Error(data.message || 'Failed to send OTP');
      }
      
      state.otpId = (data.data && (data.data.otp_id || data.data.otpId)) || '';
      
      if (!state.otpId) throw new Error('Failed to get OTP ID from response');
      
      elements.otpPhoneText.textContent = '+91' + phoneNumber;
      showOtp();
      startResendCountdown();
      setupOtpInputs();
      showSuccess('OTP sent successfully!');
      
    } catch (error) {
      console.error('Send OTP error:', error);
      
      let errorMessage = error.message || 'Failed to send OTP. Please try again.';
      if (error.message.includes('Network')) {
        errorMessage = 'Network error. Please check your connection and try again.';
      }
      
      showError(errorMessage);
      setButtonLoading(elements.getOtpBtn, false);
      setButtonLoading(elements.getOtpBtnDesktop, false);
      
      if (!elements.loginUi.classList.contains('hidden')) updateGetOtpState(elements.phoneInput, elements.getOtpBtn);
      if (!elements.loginUiDesktop.classList.contains('hidden')) updateGetOtpState(elements.phoneInputDesktop, elements.getOtpBtnDesktop);
    }
  }

  async function verifyOtp() {
    const phoneNumber = clean(elements.phoneInput.value || elements.phoneInputDesktop.value);
    const code = elements.otpBoxes.map(i => i.value.replace(/\D/g, '')).join('');
    
    if (code.length !== 6 || !state.otpId) return;
    
    setButtonLoading(elements.verifyBtn, true);
    clearOtpStatus();
    
    try {
      const authToken = await getAuthToken();
      
      const headers = {
        'shop_name': CONFIG.SHOP_NAME,
        'action': 'verifyOTP',
        'Content-Type': 'application/json'
      };
      
      if (authToken) headers['Authorization'] = authToken;
      
      const response = await fetch(CONFIG.VERIFY_OTP_URL, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          username: `+91${phoneNumber}`,
          otp: code,
          type: state.channel,
          otp_id: state.otpId,
          checkout_url: ''
        })
      });
      
      const data = await response.json();
      
      if (data.status !== 200) {
        showError(data.message || 'Verification failed');
        setButtonLoading(elements.verifyBtn, false);
        return;
      }
      
      showSuccess('OTP verified!');
      setButtonLoading(elements.verifyBtn, false);
      
      if (data.data && data.data.multipass_url) {
        
        if (data.data.customer_id) {
          localStorage.setItem('_customerId', data.data.customer_id);
        }

        try {
          const partialLeadPayload = {
            phone: phoneNumber,
            status: 'user',
            booking_type: 'ahs'
          };
          const service = URLHandler.getServiceFromPath && URLHandler.getServiceFromPath();
          if (service) {
            partialLeadPayload.service = service;
          }
          fetch(CONFIG.PARTIAL_LEADS_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(partialLeadPayload)
          }).catch(err => {
            console.warn('[athome-page] Partial lead (user) save failed:', err);
          });
        } catch (e) {
          console.warn('[athome-page] Error while sending partial lead (user):', e);
        }
        
        localStorage.setItem('_redirectAfterLogin', window.location.href);
        
        const multipassUrl = data.data.multipass_url.replace(
          'https://supertail.myshopify.com',
          'https://supertail.myshopify.com'
        );
        
        setTimeout(() => {
          window.location.href = multipassUrl;
        }, 1500);
        return;
      } else {
        // New user - create / update partial lead as "lead" for AHS flow
        try {
          const partialLeadPayload = {
            phone: phoneNumber,
            status: 'lead',
            booking_type: 'ahs'
          };
          const service = URLHandler.getServiceFromPath && URLHandler.getServiceFromPath();
          if (service) {
            partialLeadPayload.service = service;
          }
          fetch(CONFIG.PARTIAL_LEADS_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(partialLeadPayload)
          }).catch(err => {
            console.warn('[athome-page] Partial lead (lead) save failed:', err);
          });
        } catch (e) {
          console.warn('[athome-page] Error while sending partial lead (lead):', e);
        }

        // New user - show registration form
        setTimeout(() => {
          showRegistration(phoneNumber);
        }, 1500);
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      
      let errorMessage = error.message || 'Verification failed. Please try again.';
      if (error.message.includes('Network') || error.message.includes('fetch')) {
        errorMessage = 'Network error. Please check your connection and try again.';
      }
      
      showError(errorMessage);
      setButtonLoading(elements.verifyBtn, false);
    }
  }

  async function registerUser(e) {
    if (e) e.preventDefault();

    const firstName = elements.regFirstName ? elements.regFirstName.value.trim() : '';
    const lastName = elements.regLastName ? elements.regLastName.value.trim() : '';
    const email = elements.regEmail ? elements.regEmail.value.trim() : '';
    const phone = elements.regPhone ? elements.regPhone.value.trim() : '';

    // Validation
    if (!firstName || !lastName || !email || !phone) {
      showRegistrationError('Please fill in all required fields');
      return;
    }

    if (phone.length !== 10) {
      showRegistrationError('Please enter a valid 10-digit phone number');
      return;
    }

    // Simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showRegistrationError('Please enter a valid email address');
      return;
    }

    setButtonLoading(elements.registerBtn, true);
    clearRegistrationStatus();

    try {
      // Store the booking URL for redirect after multipass login
      const bookingUrl = URLHandler.constructIframeUrl(phone);
      localStorage.setItem('_redirectAfterLogin', window.location.href);

      const payload = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        source: 'at-home-booking'
      };

      const response = await fetch('https://supertails-backend.el.r.appspot.com/customer/healthcare/registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.status !== 200 && data.status !== 201) {
        const errorMessage = data.message || 'Registration failed';
        showRegistrationError(errorMessage);
        setButtonLoading(elements.registerBtn, false);
        return;
      }

      showRegistrationSuccess('Registration successful!');
      setButtonLoading(elements.registerBtn, false);

      // Store customer data
      if (data.response && data.response.customerData) {
        const customerData = {
          customer_id: data.response.customerData,
          phone: phone,
          email: email,
          first_name: firstName,
          last_name: lastName
        };
        syncCustomerData(customerData);
      }

      // Update partial lead status to "user" for this phone in AHS flow
      try {
        const partialLeadPayload = {
          phone: phone,
          status: 'user',
          booking_type: 'ahs'
        };
        const service = URLHandler.getServiceFromPath && URLHandler.getServiceFromPath();
        if (service) {
          partialLeadPayload.service = service;
        }
        fetch(CONFIG.PARTIAL_LEADS_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(partialLeadPayload)
        }).catch(err => {
          console.warn('[athome-page] Partial lead (user) save failed:', err);
        });
      } catch (e) {
        console.warn('[athome-page] Error while sending partial lead (user):', e);
      }

      // Redirect to multipass URL after successful registration
      setTimeout(function() {

        if (data.response && data.response.multipassUrl) {
          const multipassUrl = data.response.multipassUrl;
          window.location.href = multipassUrl;
        } else {
          console.error('No multipass URL received from registration API');
          showRegistrationError('Registration completed but login failed. Please try logging in manually.');
        }
      }, 1500);

    } catch(e) {
      console.error('Registration error:', e);

      let errorMessage = e.message || 'Registration failed. Please try again.';
      if (e.message.includes('Network') || e.message.includes('fetch')) {
        errorMessage = 'Network error. Please check your connection and try again.';
      }

      showRegistrationError(errorMessage);
      setButtonLoading(elements.registerBtn, false);
    }
  }

  // ========================================
  // UI STATE MANAGEMENT
  // ========================================
  
  function showLogin() {
    if (timers.countdown) {
      clearTimeout(timers.countdown);
      timers.countdown = null;
    }
    
    elements.loginUi.classList.remove('hidden');
    elements.loginUiDesktop.classList.remove('hidden');
    elements.otpUi.classList.add('hidden');
    
    if (elements.frameWrap) elements.frameWrap.style.display = 'none';
    
    const iframeBackBtn = document.getElementById('iframe-back-btn');
    if (iframeBackBtn) iframeBackBtn.remove();
    
    if (window.originalOnPopState !== undefined) {
      window.onpopstate = window.originalOnPopState;
    }
    
    state.currentScreen = 'login';
    clearOtpStatus();
    state.otpId = '';
    
    elements.otpBoxes.forEach(box => box.value = '');
    
    if (elements.verifyBtn) {
      elements.verifyBtn.disabled = true;
      elements.verifyBtn.classList.remove('is-enabled');
    }
    
    if (elements.getOtpBtn) {
      elements.getOtpBtn.disabled = false;
      elements.getOtpBtn.classList.remove('is-loading');
      setButtonLoading(elements.getOtpBtn, false);
    }
    
    if (elements.getOtpBtnDesktop) {
      elements.getOtpBtnDesktop.disabled = false;
      elements.getOtpBtnDesktop.classList.remove('is-loading');
      setButtonLoading(elements.getOtpBtnDesktop, false);
    }
    
    updateGetOtpState(elements.phoneInput, elements.getOtpBtn);
    updateGetOtpState(elements.phoneInputDesktop, elements.getOtpBtnDesktop);
  }

  function showOtp() {
    elements.loginUi.classList.add('hidden');
    elements.loginUiDesktop.classList.add('hidden');
    elements.otpUi.classList.remove('hidden');

    state.currentScreen = 'otp';
    history.pushState({ screen: 'otp' }, '', location.pathname + location.search);
    setChannel(state.channel);
  }

  function showRegistration(phoneNumber) {
    // Hide all other screens
    if (elements.loginUi) {
      elements.loginUi.classList.add('hidden');
    }
    if (elements.loginUiDesktop) {
      elements.loginUiDesktop.classList.add('hidden');
    }
    if (elements.otpUi) {
      elements.otpUi.style.display = 'none';
      elements.otpUi.classList.add('hidden');
    }

    // Show registration screen
    if (elements.registrationUi) {
      elements.registrationUi.style.display = 'block';
      elements.registrationUi.classList.remove('hidden');

      // Pre-fill phone number (readonly)
      if (elements.regPhone) {
        elements.regPhone.value = phoneNumber || localStorage.getItem('_customerPhone') || '';
      }

      // Focus on first name field
      if (elements.regFirstName) {
        setTimeout(function() {
          elements.regFirstName.focus();
        }, 100);
      }
    } else {
      console.error('Registration UI element not found');
    }

    state.currentScreen = 'registration';
    history.pushState({screen: 'registration'}, '', location.pathname + location.search);
  }

  function showIframeOnly() {
    if (elements.frameWrap) elements.frameWrap.style.display = 'block';
    if (elements.loginUi) elements.loginUi.style.display = 'none';
    if (elements.loginUiDesktop) elements.loginUiDesktop.style.display = 'none';
    if (elements.otpUi) elements.otpUi.style.display = 'none';
    if (elements.registrationUi) elements.registrationUi.style.display = 'none';
    
    clearOtpStatus();
    
    if (timers.countdown) {
      clearTimeout(timers.countdown);
      timers.countdown = null;
    }
    
    document.body.style.overflow = 'hidden';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    
    state.currentScreen = 'iframe';
    
    window.history.replaceState({ iframe: true }, '', location.href);
    
    window.originalOnPopState = window.onpopstate;
    window.history.pushState(null, '', window.location.href);
    
    window.onpopstate = function(event) {
      const previousUrl = document.referrer;
      window.history.pushState(null, '', window.location.href);
      
      sendMessageToIframe({
        type: 'BACK_HANDLER_WEB',
        previousUrl: previousUrl,
        currentUrl: window.location.href
      });
    };
    
    setTimeout(() => {
      const loadingOverlay = document.getElementById('booking-loading-overlay');
      if (loadingOverlay && loadingOverlay.style.display !== 'none') {
        if (window.showIframeErrorWithFallback) {
          window.showIframeErrorWithFallback();
        }
      }
    }, 20000);
    
  }

  // ========================================
  // CHANNEL MANAGEMENT
  // ========================================
  
  function setChannel(channel) {
    state.channel = channel === 'whatsapp' ? 'whatsapp' : 'phone';
    
    const btnText = state.channel === 'whatsapp' ? 'Get OTP on WhatsApp' : 'Get OTP';
    elements.getOtpBtn.querySelector('.btn-text').textContent = btnText;
    elements.getOtpBtnDesktop.querySelector('.btn-text').textContent = btnText;
    
    elements.waToggleLinks.forEach(link => {
      const span = link.querySelector('span');
      if (span) {
        span.textContent = state.channel === 'whatsapp' ? 'Login via SMS' : 'Login via WhatsApp';
      }
      
      const waIcon = link.querySelector('.st-wa-icon');
      if (waIcon) {
        waIcon.style.display = state.channel === 'whatsapp' ? 'none' : 'block';
      }
    });
  }

  // ========================================
  // INPUT VALIDATION
  // ========================================
  
  function updateGetOtpState(input, button) {
    if (!input || !button) return;
    
    const value = clean(input.value);
    input.value = value;
    const isValid = value.length === 10;
    button.disabled = !isValid;
    button.classList.toggle('is-enabled', isValid);
  }

  // ========================================
  // OTP HANDLING
  // ========================================
  
  function setupOtpInputs() {
    if (state.otpInputsInitialized) return;
    
    function updateVerifyButton() {
      const code = elements.otpBoxes.map(i => i.value.replace(/\D/g, '')).join('');
      const enabled = code.length === 6;
      elements.verifyBtn.disabled = !enabled;
      elements.verifyBtn.classList.toggle('is-enabled', enabled);
      
      if (enabled) {
        setTimeout(() => {
          elements.otpBoxes.forEach(box => box.blur());
          verifyOtp();
        }, 300);
      }
    }
    
    function onInput(e) {
      e.target.value = e.target.value.replace(/\D/g, '');
      if (e.target.value && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
      updateVerifyButton();
    }
    
    function onKeyDown(e) {
      if (e.key === 'Backspace' && !e.target.value && e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      }
    }
    
    elements.otpBoxes.forEach(box => {
      box.addEventListener('input', onInput);
      box.addEventListener('keydown', onKeyDown);
    });
    
    elements.otpBoxes[0].focus();
    updateVerifyButton();
    state.otpInputsInitialized = true;
  }

  function startResendCountdown() {
    let remaining = CONFIG.RESEND_TIMEOUT;
    elements.resendBtn = document.getElementById('stResendBtn');
    elements.resendTimer = document.getElementById('stResendTimer');
    elements.resendBtn.disabled = true;
    
    function tick() {
      remaining -= 1;
      if (remaining <= 0) {
        elements.resendBtn.disabled = false;
        elements.resendBtn.textContent = 'Resend OTP';
        timers.countdown = null;
      } else {
        if (elements.resendTimer) elements.resendTimer.textContent = String(remaining);
        timers.countdown = setTimeout(tick, 1000);
      }
    }
    
    if (elements.resendTimer) elements.resendTimer.textContent = '60';
    timers.countdown = setTimeout(tick, 1000);
  }

  // ========================================
  // STATUS MESSAGES
  // ========================================
  
  function showOtpStatus(type, message) {
    const statusEl = document.getElementById('stOtpStatus');
    const statusIcon = document.getElementById('stOtpStatusIcon');
    const statusText = document.getElementById('stOtpStatusText');
    
    if (statusEl && statusIcon && statusText) {
      statusEl.className = 'st-otp-ui__status';
      statusIcon.className = 'st-otp-ui__status-icon';
      statusIcon.innerHTML = '';
      
      statusEl.classList.add(type);
      statusIcon.classList.add(type);
      statusText.textContent = message;
      
      if (type === 'success') {
        statusIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_292_5784)"><path d="M13.25 2.50492C14.3812 3.15806 15.3222 4.09531 15.9799 5.22389C16.6375 6.35248 16.989 7.63325 16.9996 8.93942C17.0101 10.2456 16.6794 11.5319 16.04 12.6709C15.4007 13.81 14.4749 14.7623 13.3544 15.4337C12.2339 16.105 10.9575 16.472 9.65157 16.4985C8.34562 16.5249 7.05541 16.2098 5.90867 15.5844C4.76192 14.9589 3.7984 14.0448 3.1135 12.9326C2.4286 11.8203 2.04606 10.5485 2.00375 9.24292L2 8.99992L2.00375 8.75692C2.04575 7.46166 2.42266 6.19939 3.09773 5.09316C3.7728 3.98694 4.72299 3.07451 5.85567 2.44483C6.98835 1.81515 8.26486 1.48972 9.56075 1.50025C10.8566 1.51078 12.1277 1.85692 13.25 2.50492ZM12.2802 6.96967C12.1511 6.84054 11.9793 6.76296 11.797 6.7515C11.6147 6.74004 11.4346 6.79548 11.2902 6.90742L11.2198 6.96967L8.75 9.43867L7.78025 8.46967L7.70975 8.40742C7.56544 8.29556 7.38528 8.24019 7.20305 8.25168C7.02083 8.26318 6.84906 8.34076 6.71995 8.46987C6.59084 8.59897 6.51326 8.77075 6.50177 8.95297C6.49027 9.1352 6.54564 9.31536 6.6575 9.45967L6.71975 9.53017L8.21975 11.0302L8.29025 11.0924C8.42178 11.1945 8.58352 11.2499 8.75 11.2499C8.91648 11.2499 9.07822 11.1945 9.20975 11.0924L9.28025 11.0302L12.2802 8.03017L12.3425 7.95967C12.4544 7.81537 12.5099 7.63518 12.4984 7.45291C12.487 7.27064 12.4094 7.09881 12.2802 6.96967Z" fill="#EF6C00"/></g><defs><clipPath id="clip0_292_5784"><rect width="18" height="18" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>';
      }
      
      statusEl.style.display = 'flex';
      
      const hideDelay = type === 'success' ? 3000 : 5000;
      timers.otpStatus = setTimeout(() => clearOtpStatus(), hideDelay);
    }
  }

  function clearOtpStatus() {
    const statusEl = document.getElementById('stOtpStatus');
    const statusIcon = document.getElementById('stOtpStatusIcon');
    
    if (statusEl) statusEl.style.display = 'none';
    if (statusIcon) statusIcon.innerHTML = '';
    if (timers.otpStatus) {
      clearTimeout(timers.otpStatus);
      timers.otpStatus = null;
    }
  }

  function showError(message, duration = 5000) {
    showOtpStatus('error', message);
  }

  function showSuccess(message, duration = 3000) {
    showOtpStatus('success', message);
  }

  // Registration Status Functions
  function showRegistrationStatus(type, message) {
    const statusEl = document.getElementById('stRegistrationStatus');
    const statusIcon = document.getElementById('stRegistrationStatusIcon');
    const statusText = document.getElementById('stRegistrationStatusText');

    if (statusEl && statusIcon && statusText) {
      statusEl.className = 'st-registration-ui__status';
      statusIcon.className = 'st-registration-ui__status-icon';
      statusIcon.innerHTML = '';

      statusEl.classList.add(type);
      statusIcon.classList.add(type);
      statusText.textContent = message;

      statusEl.style.display = 'flex';
    }
  }

  function clearRegistrationStatus() {
    const statusEl = document.getElementById('stRegistrationStatus');
    if (statusEl) {
      statusEl.style.display = 'none';
    }
  }

  function showRegistrationError(message, duration = 5000) {
    showRegistrationStatus('error', message);
    setTimeout(function() {
      clearRegistrationStatus();
    }, duration);
  }

  function showRegistrationSuccess(message, duration = 3000) {
    showRegistrationStatus('success', message);
    setTimeout(function() {
      clearRegistrationStatus();
    }, duration);
  }

  // ========================================
  // IFRAME HANDLERS
  // ========================================
  
  function sendMessageToIframe(message) {
    if (elements.iframe && elements.iframe.contentWindow) {
      try {
        elements.iframe.contentWindow.postMessage(message, CONFIG.IFRAME_BASE_URL);
      } catch (error) {
        console.error('Error sending message to iframe:', error);
      }
    }
  }

  window.handleIframeLoad = function() {
    const currentSrc = elements.iframe ? elements.iframe.src : '';
    
    if (currentSrc === 'about:blank') {
      return;
    }
    
    state.iframeLoaded = true;
    
    const loadingOverlay = document.getElementById('booking-loading-overlay');
    if (loadingOverlay) loadingOverlay.style.display = 'none';
  };

  window.handleIframeError = function() {
    console.error('Iframe failed to load');
    state.iframeError = true;
    
    if (window.showIframeError) {
      window.showIframeError();
    }
  };

  window.showIframeError = function() {
    const loadingOverlay = document.getElementById('booking-loading-overlay');
    const errorOverlay = document.getElementById('booking-error-overlay');
    
    if (loadingOverlay) loadingOverlay.style.display = 'none';
    if (errorOverlay) {
      errorOverlay.style.display = 'flex';
      
      const errorTitle = errorOverlay.querySelector('.booking-error-title');
      const errorMessage = errorOverlay.querySelector('.booking-error-message');
      
      if (errorTitle) errorTitle.textContent = 'Booking system temporarily unavailable';
      if (errorMessage) errorMessage.textContent = "We're having trouble loading the booking system. Please try refreshing the page or contact support if the issue persists.";
    }
  };

  window.showIframeErrorWithFallback = function() {
    const loadingOverlay = document.getElementById('booking-loading-overlay');
    const errorOverlay = document.getElementById('booking-error-overlay');
    
    if (loadingOverlay) loadingOverlay.style.display = 'none';
    if (errorOverlay) {
      errorOverlay.style.display = 'flex';
      
      const errorTitle = errorOverlay.querySelector('.booking-error-title');
      const errorMessage = errorOverlay.querySelector('.booking-error-message');
      
      if (errorTitle) errorTitle.textContent = 'Unable to load booking system';
      if (errorMessage) errorMessage.innerHTML = 'The booking system is currently unavailable. You can:<br>• Try refreshing the page<br>• Call us directly for booking assistance<br>• Visit our main website for other services';
    }
  };

  function retryIframeLoad() {
    state.iframeError = false;
    state.iframeLoaded = false;
    
    const loadingOverlay = document.getElementById('booking-loading-overlay');
    const errorOverlay = document.getElementById('booking-error-overlay');
    
    if (loadingOverlay) loadingOverlay.style.display = 'flex';
    if (errorOverlay) errorOverlay.style.display = 'none';
    
    if (elements.iframe) elements.iframe.src = elements.iframe.src;
  }

  // ========================================
  // CUSTOMER DATA SYNC
  // ========================================
  
  function syncCustomerData(customerData) {
    try {
      const phoneNumber = customerData.phone || localStorage.getItem('_customerPhone');
      
      if (phoneNumber) {
        localStorage.setItem('_cshopifyIL', phoneNumber);
        localStorage.setItem('_customerPhone', phoneNumber);
      }
      
      if (customerData.customer_id) localStorage.setItem('_customerId', customerData.customer_id);
      if (customerData.email) localStorage.setItem('_customerEmail', customerData.email);
      if (customerData.first_name) localStorage.setItem('_customerFirstName', customerData.first_name);
      if (customerData.last_name) localStorage.setItem('_customerLastName', customerData.last_name);
      
      localStorage.setItem('_session_expire_', 'false');
      localStorage.setItem('_showLogin', 'false');
      
      document.body.dispatchEvent(new CustomEvent('customer:data_updated', {
        detail: {
          customer_id: customerData.customer_id || null,
          phone: phoneNumber,
          email: customerData.email || null,
          source: 'booking_otp'
        }
      }));
      
    } catch (error) {
      console.error('Error syncing customer data:', error);
    }
  }

  // ========================================
  // KEYBOARD HANDLING
  // ========================================
  
  function setupKeyboardHandling() {
    const loginSheet = document.querySelector('.st-login-ui__card');
    const maxLiftPx = Math.min(Math.floor(window.innerHeight * 0.001), 30);
    let currentOffset = 0;
    let resizeTimeout;
    let isKeyboardOpen = false;

    function applyOffset(px, element) {
      px = Math.max(0, Math.min(Math.round(px), maxLiftPx));
      if (Math.abs(px - currentOffset) < 2) return;
      currentOffset = px;
      if (element && element.classList.contains('st-login-ui__card')) {
        element.style.setProperty('--kb-offset', 10 + 'px');
      }
    }

    function computeLift() {
      const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const margin = 10;
      
      if (loginSheet && !elements.loginUi.classList.contains('hidden')) {
        const btnBottom = elements.getOtpBtn.getBoundingClientRect().bottom;
        const needed = Math.max(0, btnBottom - (vh - margin));
        applyOffset(needed, loginSheet);
      }
    }

    function onStableResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(computeLift, 50);
    }

    function onKeyboardOpen() {
      isKeyboardOpen = true;
      setTimeout(computeLift, 150);
    }

    function onKeyboardClose() {
      isKeyboardOpen = false;
      setTimeout(() => applyOffset(0, loginSheet), 100);
    }

    elements.phoneInput.addEventListener('focus', onKeyboardOpen, { passive: true });
    elements.phoneInput.addEventListener('blur', onKeyboardClose, { passive: true });
    elements.phoneInputDesktop.addEventListener('focus', onKeyboardOpen, { passive: true });
    elements.phoneInputDesktop.addEventListener('blur', onKeyboardClose, { passive: true });

    elements.otpBoxes.forEach(box => {
      box.addEventListener('focus', onKeyboardOpen, { passive: true });
      box.addEventListener('blur', function() {
        setTimeout(() => {
          const hasFocus = elements.otpBoxes.some(b => b === document.activeElement);
          if (!hasFocus) onKeyboardClose();
        }, 50);
      }, { passive: true });
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onStableResize, { passive: true });
    } else {
      window.addEventListener('resize', onStableResize, { passive: true });
    }

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        if (isKeyboardOpen) computeLift();
      }, 300);
    }, { passive: true });
  }

  // ========================================
  // EVENT LISTENERS
  // ========================================
  
  function setupEventListeners() {
    // Phone input validation
    elements.phoneInput.addEventListener('input', () => updateGetOtpState(elements.phoneInput, elements.getOtpBtn));
    elements.phoneInput.addEventListener('blur', () => updateGetOtpState(elements.phoneInput, elements.getOtpBtn));
    elements.phoneInputDesktop.addEventListener('input', () => updateGetOtpState(elements.phoneInputDesktop, elements.getOtpBtnDesktop));
    elements.phoneInputDesktop.addEventListener('blur', () => updateGetOtpState(elements.phoneInputDesktop, elements.getOtpBtnDesktop));

    // OTP buttons
    elements.getOtpBtn.addEventListener('click', sendOtp);
    elements.getOtpBtnDesktop.addEventListener('click', sendOtp);
    elements.resendBtn.addEventListener('click', sendOtp);
    elements.verifyBtn.addEventListener('click', verifyOtp);

    // Retry button
    if (elements.retryBtn) {
      elements.retryBtn.addEventListener('click', retryIframeLoad);
    }

    // WhatsApp toggle
    elements.waToggleLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (!elements.otpUi.classList.contains('hidden')) {
          elements.otpBoxes.forEach(box => box.value = '');
          clearOtpStatus();
          
          if (timers.countdown) {
            clearTimeout(timers.countdown);
            timers.countdown = null;
          }
          
          state.otpId = '';
          const newChannel = state.channel === 'phone' ? 'whatsapp' : 'phone';
          setChannel(newChannel);
          showLogin();
        } else {
          setChannel(state.channel === 'phone' ? 'whatsapp' : 'phone');
        }
      });
    });

    // Back navigation
    const editPhoneBtn = document.querySelector('.st-otp-ui__edit');
    const backBtn = document.querySelector('.st-otp-ui__back');
    
    if (editPhoneBtn) {
      editPhoneBtn.onclick = (e) => {
        e.preventDefault();
        history.back();
      };
    }
    
    if (backBtn) {
      backBtn.onclick = (e) => {
        e.preventDefault();
        history.back();
      };
    }

    // Browser back button
    window.addEventListener('popstate', () => {
      if (state.currentScreen === 'otp') {
        showLogin();
      } else if (state.currentScreen === 'login') {
        showLogin();
      }
    });

    // Escape key for iframe
    document.addEventListener('keydown', (event) => {
      if (state.currentScreen === 'iframe' && event.key === 'Escape') {
        window.location.replace('/');
      }
    });

    // Network monitoring
    window.addEventListener('online', () => {
      const statusEl = document.getElementById('stOtpStatus');
      if (statusEl && statusEl.classList.contains('error')) {
        const statusText = statusEl.querySelector('.st-otp-ui__status-text');
        if (statusText && statusText.textContent.includes('Network')) {
          clearOtpStatus();
        }
      }
    });

    window.addEventListener('offline', () => {
      showError('Network connection lost. Please check your internet connection.');
    });

    // Registration form submit
    if (elements.registrationForm) {
      elements.registrationForm.addEventListener('submit', registerUser);
    }
  }

  // ========================================
  // INITIALIZATION
  // ========================================
  
  function init() {
    
    // Set initial states
    updateGetOtpState(elements.phoneInput, elements.getOtpBtn);
    updateGetOtpState(elements.phoneInputDesktop, elements.getOtpBtnDesktop);
    elements.otpUi.classList.add('hidden');
    setChannel('phone');
    
    // Setup event listeners
    setupEventListeners();
    setupKeyboardHandling();
    
    // Check if customer is already logged in
    const storedPhone = localStorage.getItem('_customerPhone') || window.currentLoginPhone;
    
    if (storedPhone) {
      URLHandler.constructIframeUrl(storedPhone);
    } else {
      console.log('No stored phone, iframe will be updated after login');
    }
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// ========================================
// MESSAGE HANDLER FOR BOOKING APP
// ========================================
window.addEventListener('message', (event) => {
  const { event: eventName, data } = event.data;
  if (eventName) {
    // Send to data layer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...data
    });
  }

  if (eventName === 'BOOKING_COMPLETED') {
    window.location.href = '/';
  }

  if (eventName === 'GO_BACK') {
    window.location.href = data.page || '/';
  }
});

